import { render, staticRenderFns } from "./press-logos-desktop.vue?vue&type=template&id=44e4a0c7&scoped=true&lang=pug&"
var script = {}
import style0 from "./press-logos-desktop.vue?vue&type=style&index=0&id=44e4a0c7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e4a0c7",
  null
  
)

export default component.exports